module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-brk"
  }), _vm._v(" "), _c('p', {
    staticClass: "bmh"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 1: "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Slipping on the Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 2: "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Because a Fisher Softly Creeping, Left Disease While I Was Sleeping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 3: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s Amazing How You Can Spit Rice Through My Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 4: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m Gonna Shoot You Right Down, Ride Off with Your Feet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 5: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All My Jeans Are Filled")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 6: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s Been a Hard Day’s Night, I Should Be Sleeping on Kellogg’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 7: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Say Love Is More or Less a Gibbon Thing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 8: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Love Is Like a Chip on the Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 9: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Will Iron Each Other")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 10: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Something in the Way She Moos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 11: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Give Me My Porpoise When You Get Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 12: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Was Feeling Kinda Seasick but the Crowd Called Arthur Moor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 13: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Shy Bruised Eyes Please Go Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 14: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Colors of the Rambo, So Pretty in Disguise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 15: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Pirates, Yes, They’re Rabbi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter 16: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Start Spreading Manures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("Chapter 17: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And All the Lettuce Was Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/map#map",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/authors_note#aun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Colin Cotterill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0